<template>
  <div>
    <div id="overlay" v-if="fetchingData">
      <div class="spinner"></div>
    </div>
    <h1>
      Air Quality Site Management
      <small>
        Do you have a certificate of operation with Cook County Department of Environment and Sustainability?
      </small>
    </h1>
    <div class="row justify-content-left">
      <div class="col-12 col-md-6">
        <label><strong>If yes</strong>, enter your site number to continue</label>
        <base-input v-model="form.siteNumber"
                    :validation="$v.form.siteNumber"
                    placeholder="Site Number"
                    v-on:keyup.enter="searchPermitNumber">
        </base-input>
        <button class="btn btn-primary" @click="searchSiteNumber" slot="input-append">Search</button> <button style="margin-left: 5%;" class="btn btn-primary" @click="showExample">Where is my Site Number?</button>
      </div>
      <!--
      <p style="color: red;">NOTE: The Certificate of Operation (COO) payment deadline has passed.  If you have not paid for your 2020 COO, your account balance will be adjudicated by the Cook County Dept of Administrative Hearings.  A notification/citation will be sent to your facility with further instructions.</p>
      -->
    </div>
    <div class="row justify-content-left">
      <div class="col-12 col-md-6">
        <label style="margin-top: 2%;"><strong>If no</strong>, please apply</label>
      </div>
    </div>
    <div class="row justify-content-left">
      <div class="col-12 col-md-6">
        <button class="btn btn-primary" @click="siteRequest" slot="input-append">Create New Site</button>
      </div>
    </div>
  </div>
</template>
<script>
import BaseInput from '@/components/BaseInput';
import { SiteAuthenticatonValidation } from '~/js/FormValidations';
import { SiteAuthentication } from '~/js/FormObjects';
import { getSite } from '~/js/FormFunctions';
import Vue from 'vue';
import VueSweetalert2 from 'vue-sweetalert2';
import sampleImage from '../../assets/sample.png';

Vue.use(VueSweetalert2);

export default {
  name: 'SiteAuthentication',
  components: { BaseInput },
  data() {
    return {
      isValidNum: false,
      fetchingData: false,
      erroMessage: '',
      form: new SiteAuthentication(),
    };
  },
  validations: {
    form: new SiteAuthenticatonValidation(),
  },
  methods: {
    searchSiteNumber() {
      if (this.$v.$invalid || this.form.siteNumber === null || this.form.siteNumber.match(/^ *$/) !== null) {
        this.$v.$touch();
        this.$notify('Invalid site number given', 'error');
        return;
      }
      const self = this;
      this.fetchingData = true;

      getSite(this.form.siteNumber)
        .then((data) => {
          self.fetchingData = false;
          self.$router.push({ name: 'AirApplication', params: { siteNumber: self.form.siteNumber } });
        })
        .catch(() => {
          self.fetchingData = false;
        });
    },
    siteRequest() {
      this.$router.push({ name: 'SiteRequest', query: this.$route.query });
    },
    showExample() {
      this.$swal({
        text: 'Your \'Site Number\' can be found under the \'Site Information\' section of your Statement of Account.',
        imageUrl: '/DesWebPortal/Static/img/sample.46cebaaa.png',
        imageWidth: 600,
        imageHeight: 400,
        customClass: 'swal-wide',
        imageAlt: 'sample image',
        animation: false,
      });
    },
  },
};

</script>
